import React from 'react';
import { cn } from '@/lib/utils';

export interface MetricCardGridProps extends React.HTMLAttributes<HTMLDivElement> {
  columns?: 2 | 3 | 4 | 5 | 6 | 7;
}

const columnClasses: Record<NonNullable<MetricCardGridProps['columns']>, string> = {
  2: 'grid-cols-1 gap-4 sm:grid-cols-2',
  3: 'grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3',
  4: 'grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4',
  5: 'grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-5',
  6: 'grid-cols-2 gap-4 sm:grid-cols-3 xl:grid-cols-6',
  7: 'grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-7',
};

export function MetricCardGrid({
  columns = 4,
  className,
  children,
  ...props
}: MetricCardGridProps) {
  return (
    <div className={cn('grid', columnClasses[columns], className)} {...props}>
      {children}
    </div>
  );
}
